import { Clock, Gauge } from "lucide-react";
import { Badge } from "./Badge";
import { formatDuration } from "../../lib/format";

/** Actual freshness vs target. Never claims fresh without a measured lag. */
export function FreshnessBadge({ lagSeconds, targetSeconds }: { lagSeconds: number | null | undefined; targetSeconds?: number | null }) {
  if (lagSeconds === null || lagSeconds === undefined)
    return (
      <Badge tone="neutral" icon={<Clock className="size-3" aria-hidden />}>
        lag unknown
      </Badge>
    );
  const target = targetSeconds ?? null;
  const tone = target === null ? "info" : lagSeconds <= target ? "good" : lagSeconds <= target * 4 ? "warning" : "critical";
  return (
    <Badge tone={tone} icon={<Clock className="size-3" aria-hidden />}>
      {formatDuration(lagSeconds)} lag{target !== null ? ` · target ${formatDuration(target)}` : ""}
    </Badge>
  );
}

export function LatencyBadge({ ms, label = "p95" }: { ms: number | null | undefined; label?: string }) {
  if (ms === null || ms === undefined)
    return (
      <Badge tone="neutral" icon={<Gauge className="size-3" aria-hidden />}>
        {label} —
      </Badge>
    );
  const tone = ms <= 100 ? "good" : ms <= 300 ? "info" : ms <= 1000 ? "warning" : "critical";
  return (
    <Badge tone={tone} icon={<Gauge className="size-3" aria-hidden />}>
      {label} {ms}ms
    </Badge>
  );
}

const sensitivityTone: Record<string, "good" | "neutral" | "info" | "warning" | "serious" | "critical"> = {
  PUBLIC: "good",
  LOW_RISK: "good",
  BUSINESS_DATA: "info",
  INTERNAL: "warning",
  CONFIDENTIAL: "warning",
  PII: "serious",
  FINANCIAL: "serious",
  SENSITIVE_PII: "critical",
  HEALTH: "critical",
  AUTHENTICATION_SECRET: "critical",
  PROHIBITED: "critical",
};
export function SensitivityBadge({ value }: { value: string }) {
  return <Badge tone={sensitivityTone[value] ?? "neutral"}>{value.replace(/_/g, " ")}</Badge>;
}
